// Thin, type-safe wrapper around the Meta Pixel (fbq) that is loaded by the
// base code in index.html. Every call is guarded so the app never breaks if
// the pixel is blocked (ad blockers) or hasn't loaded yet.

export const META_PIXEL_ID = '2772011143172382';

type FbqParams = Record<string, unknown>;

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

/**
 * Track a standard Meta event (e.g. "Lead", "InitiateCheckout").
 * Use standard event names so Meta recognizes and optimizes for them.
 */
export function trackMetaEvent(event: string, params?: FbqParams): void {
  try {
    window.fbq?.('track', event, params);
  } catch {
    // Never let analytics break the user flow.
  }
}

/**
 * Track a custom Meta event for actions specific to Moodra that don't map to
 * one of the standard events (e.g. "TasterStarted").
 */
export function trackMetaCustomEvent(event: string, params?: FbqParams): void {
  try {
    window.fbq?.('trackCustom', event, params);
  } catch {
    // Never let analytics break the user flow.
  }
}

/**
 * Enable Advanced Matching for subsequent events by re-initializing the pixel
 * with user data. The pixel normalizes and SHA-256 hashes the value in the
 * browser before sending — the raw email is never transmitted to Meta.
 */
export function setMetaAdvancedMatching(email: string): void {
  if (!email) return;
  try {
    window.fbq?.('init', META_PIXEL_ID, { em: email.trim().toLowerCase() });
  } catch {
    // Never let analytics break the user flow.
  }
}
